import script from "./EditOnboardingMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditOnboardingMessage.vue?vue&type=script&setup=true&lang=js"

import "./EditOnboardingMessage.vue?vue&type=style&index=0&id=145bb8b4&scoped=true&lang=css"
import "./EditOnboardingMessage.vue?vue&type=style&index=1&id=145bb8b4&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145bb8b4"]])

export default __exports__